import { Route } from '@angular/router';
import { AuthGuard } from '@services/auth-guard/authGuard';

export default [
    {
        path: 'location',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'customer',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'device',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'terminal',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'contract',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'settlement',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'transaction',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'user',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    },
    {
        path: 'coupon',
        loadComponent: () => import('@components/search/search-page/search-category-result/search-category-result.component').then(m => m.SearchCategoryResultComponent),
        canActivate: [AuthGuard]
    }
] satisfies Route[];
